function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.8,
  cx: 19,
  cy: 19,
  r: 19,
  fill: "#FF8D10"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.9 14.5V24.7857C28.9 25.7321 28.1273 26.5 27.175 26.5H12.225C11.2727 26.5 10.5 25.7321 10.5 24.7857V14.5C10.5 13.5536 11.2727 12.7857 12.225 12.7857H15.3875L15.8295 11.6107C16.0811 10.9429 16.7244 10.5 17.4431 10.5H21.9533C22.672 10.5 23.3153 10.9429 23.5669 11.6107L24.0125 12.7857H27.175C28.1273 12.7857 28.9 13.5536 28.9 14.5ZM24.0125 19.6429C24.0125 17.2786 22.0791 15.3571 19.7 15.3571C17.3209 15.3571 15.3875 17.2786 15.3875 19.6429C15.3875 22.0071 17.3209 23.9286 19.7 23.9286C22.0791 23.9286 24.0125 22.0071 24.0125 19.6429ZM22.8625 19.6429C22.8625 21.375 21.443 22.7857 19.7 22.7857C17.957 22.7857 16.5375 21.375 16.5375 19.6429C16.5375 17.9107 17.957 16.5 19.7 16.5C21.443 16.5 22.8625 17.9107 22.8625 19.6429Z",
  fill: "white"
});

const SvgCamera = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 38,
  viewBox: "0 0 38 38",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCamera, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/camera.fc4a56fe.svg";
export { ForwardRef as ReactComponent };